import * as React from "react";
import { Drawer } from "@mui/material";
import { DrawerHeader } from "components/DrawerHeader/DrawerHeader";
import { DrawerBody } from "components/DrawerBody/DrawerBody";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
import { MediaProjectType, SelectProjectTypeStep } from "./steps/SelectMediaProjectTypeStep/SelectProjectTypeStep";
import { CreateMediaProjectStep } from "./steps/CreateMediaProjectStep/CreateMediaProjectStep";

interface Props {
  onClose: () => void;
  onSuccess: () => void;
}

enum Step {
  SELECT_PROJECT_TYPE = "SELECT_PROJECT_TYPE",
  SUBMIT_PROJECT = "SUBMIT_PROJECT"
}

const CreateMediaTranslationPanel: React.FC<Props> = ({ onClose, onSuccess }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [currentStep, setCurrentStep] = React.useState(Step.SELECT_PROJECT_TYPE);
  const [selectedProjectType, setSelectedProjectType] = React.useState<MediaProjectType>();

  const onProjectTypeSelected = React.useCallback((mediaProjectType: MediaProjectType) => {
    setCurrentStep(Step.SUBMIT_PROJECT);
    setSelectedProjectType(mediaProjectType);
  }, []);

  return (
    <Drawer
      open={true}
      anchor="right"
      PaperProps={{
        role: "dialog",
        "aria-modal": true,
        "aria-labelledby": "create-media-translation-panel-title",
        sx: { width: isSmallScreen ? "100vw" : "50vw" }
      }}
      onClose={onClose}
    >
      <DrawerHeader
        title={t("machineTranslation.mediaTranslation.createPanelTitle")}
        titleId="create-media-translation-panel-title"
        onClose={onClose}
      />
      <DrawerBody>
        {currentStep === Step.SELECT_PROJECT_TYPE && <SelectProjectTypeStep onNext={onProjectTypeSelected} />}
        {currentStep === Step.SUBMIT_PROJECT && selectedProjectType && (
          <CreateMediaProjectStep onClose={onClose} onSuccess={onSuccess} mediaProjectType={selectedProjectType} />
        )}
      </DrawerBody>
    </Drawer>
  );
};

export { CreateMediaTranslationPanel };
